import { render, staticRenderFns } from "./ModuleView.vue?vue&type=template&id=59674469&scoped=true&"
import script from "./ModuleView.vue?vue&type=script&lang=ts&"
export * from "./ModuleView.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleView.vue?vue&type=style&index=0&id=59674469&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59674469",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VMain,VRow})
